import React from 'react';
import { useScrollReveal } from './useScrollReveal';

const STEPS = [
  {
    number: '01',
    title: 'Share your celebration vision',
    description: 'Tell us your event type, guest count, venue constraints, budget, and style preference. Takes under 2 minutes.',
    badge: 'Birthday · Shower · Anniversary · Dinner',
  },
  {
    number: '02',
    title: 'Explore 4 bespoke theme concepts',
    description: 'Our AI director crafts tailored themes with curated color palettes, visual moodboards, and decor recommendations.',
    badge: 'Hex palettes · Spatial advice · Fit scores',
  },
  {
    number: '03',
    title: 'Launch your complete studio plan',
    description: 'Get an interactive timeline, shopping checklist with Rent vs. Buy pricing, and collaborative sharing tools.',
    badge: 'Shopping · Budget · Timeline · Menu',
  },
];

export default function HowItWorksSection({ sectionRef }) {
  const reveal = useScrollReveal();

  return (
    <section
      id="how-it-works"
      ref={sectionRef}
      className="py-24 sm:py-32 px-4 sm:px-6 relative overflow-hidden w-full max-w-full"
      style={{ backgroundColor: 'var(--brand-cream)' }}
    >
      <div className="max-w-6xl mx-auto">

        {/* Section Header */}
        <div className="text-center mb-16 sm:mb-20 sr-item" ref={reveal}>
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold tracking-wider uppercase mb-3 bg-stone-100 text-stone-700 border border-stone-200">
            How It Works
          </div>
          <h2
            className="font-extrabold leading-tight text-stone-950 tracking-tight"
            style={{ fontSize: 'clamp(2rem, 4.2vw, 3rem)' }}
          >
            Three steps to a party you'll be proud of.
          </h2>
          <p className="mt-3 text-base sm:text-lg text-stone-500 max-w-md mx-auto">
            Intuitive, guided, and completely free to start.
          </p>
        </div>

        {/* Steps Grid */}
        <div className="relative sr-stagger" ref={reveal}>

          {/* Desktop Connecting Line */}
          <div
            className="hidden lg:block absolute top-10 left-0 right-0 h-px pointer-events-none"
            style={{
              background: 'linear-gradient(90deg, transparent, #E7E5E4 15%, #E7E5E4 85%, transparent)',
              marginLeft: '12%',
              marginRight: '12%',
            }}
          />

          <div className="grid sm:grid-cols-3 gap-6 lg:gap-8">
            {STEPS.map(({ number, title, description, badge }) => (
              <div
                key={number}
                className="sr-item card-editorial p-7 flex flex-col items-center text-center relative z-10 hover:-translate-y-1 transition-transform"
              >
                {/* Step number badge */}
                <div className="w-12 h-12 rounded-2xl bg-stone-950 text-white flex items-center justify-center font-mono font-bold text-sm mb-6 shadow-md">
                  {number}
                </div>

                {/* Content */}
                <h3 className="font-extrabold text-lg text-stone-900 mb-2.5 leading-snug">
                  {title}
                </h3>
                <p className="text-sm text-stone-600 leading-relaxed mb-5">
                  {description}
                </p>

                {/* Tag pill */}
                <span className="mt-auto text-[11px] font-semibold text-stone-600 bg-stone-100 px-3 py-1 rounded-full border border-stone-200/80">
                  {badge}
                </span>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}
